import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  "@global": {
    html: {
      scrollBehavior: "smooth",
    },
    "@keyframes blinking": {
      "0%": {
        backgroundColor: "#DFEBFD",
      },
      "100%": {
        backgroundColor: "white",
      },
    },
  },
  wrapperPhases: {
    borderTop: "1px solid #F8F7F4",
    marginBottom: theme.spacing(2.5),
    flex: 1,
    minHeight: "fit-content",
    borderRadius: theme.spacing(1.25),
  },
  iconEdit: {
    marginLeft: theme.spacing(1.25),
    fontSize: "25px",
    color: "#A0A0A0",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  wrapperTitle: {
    display: "flex",
    flexDirection: "column",
  },
  titlePhases: {
    color: "#BCBCBC",
    textTransform: "uppercase",
    fontSize: "12px",
    fontWeight: "bold",
  },
  wrapperTitleWeek: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-start",
      flexDirection: "column",
    },
    "& svg:hover": {
      cursor: "pointer",
    },
  },
  titleWeek: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: "20px",
    color: "black",
    marginRight: theme.spacing(1.25),
    "& div:first-child": {
      marginRight: theme.spacing(1.25),
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  wrapperLastIcon: {
    display: "flex",
    alignItems: "center",
  },
  line: {
    width: "1px",
    height: "100%",
    margin: `0 ${theme.spacing(1.25)}`,
    backgroundColor: "#DADADA",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "1px",
      margin: `${theme.spacing(1.25)} 0`,
    },
  },
  titleCoachNote: {
    fontSize: "10px",
    fontWeight: "bold",
    textTransform: "uppercase",
    color: "#434343",
    marginTop: theme.spacing(1.25),
  },
  input: {
    marginTop: theme.spacing(0.875),
    paddingLeft: theme.spacing(1.25),
    width: "700px",
    fontSize: "15px",
    resize: "none",
  },
  descriptionPublished: {
    marginTop: theme.spacing(0.875),
    borderRadius: theme.spacing(0.875),
    maxWidth: "700px",
    wordWrap: "break-word",
  },
  description: {
    marginTop: theme.spacing(0.875),
    borderRadius: theme.spacing(0.875),
    maxWidth: "700px",
    wordWrap: "break-word",
    backgroundColor: "#F9F9F9",
    padding: theme.spacing(1.5),
    transition: "0.3s ease",
    "&:hover": {
      cursor: "text",
      backgroundColor: "#F8F8F8",
      boxShadow: "0 0 10px 0px #969693",
    },
  },
  wrapperWorkouts: {
    marginTop: theme.spacing(2.5),
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
    gridGap: theme.spacing(1.5),
    alignItems: "stretch",
  },
  wrapperPhasesAnimation: {
    animation: "$blinking 10s",
  },
  inputLabel: {
    fontSize: "12px",
    textTransform: "uppercase",
    fontWeight: "bold",
    color: "#8F8F8F",
  },
  selectInput: {
    borderRadius: theme.spacing(1),
  },
  // New styles for menu layout
  menuContainer: {
    padding: theme.spacing(3),
  },
  menuGridContainer: {
    padding: theme.spacing(2),
    "& .MuiGrid-item": {
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
  },
  button: {
    borderRadius: theme.spacing(1),
    minWidth: theme.spacing(10),
  },
}));

export default useStyles;
